import axios from 'axios';
import { UNKNOWN_ERROR } from '../../../../../../helpers/Constants';
import { RequirementApiResponse } from '../../interfaces';

const fetchRequirements = async (operationId: number) => {
  try {
    const { data } = await axios.get<RequirementApiResponse>(
      `/api/requirement/order/${operationId}`
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error?.response?.data?.message);
    } else {
      throw new Error(UNKNOWN_ERROR);
    }
  }
};

export default fetchRequirements;
